import { Button, Result } from 'antd';

export function ErrorPage() {
  return (
    <Result
      status="500"
      title="500"
      subTitle="内部エラーが発生しました。お手数ですが再度お試しください。"
      extra={
        <Button type="primary" size="large" href="/">
          Topに戻る
        </Button>
      }
    />
  );
}
